import { render, staticRenderFns } from "./product-recent.vue?vue&type=template&id=3855cfb6&"
import script from "./product-recent.vue?vue&type=script&lang=js&"
export * from "./product-recent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3855cfb6')) {
      api.createRecord('3855cfb6', component.options)
    } else {
      api.reload('3855cfb6', component.options)
    }
    module.hot.accept("./product-recent.vue?vue&type=template&id=3855cfb6&", function () {
      api.rerender('3855cfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/product-recent.vue"
export default component.exports